import { render, staticRenderFns } from "./alarmSetting.vue?vue&type=template&id=19613617&scoped=true"
import script from "./alarmSetting.vue?vue&type=script&lang=js"
export * from "./alarmSetting.vue?vue&type=script&lang=js"
import style0 from "./alarmSetting.vue?vue&type=style&index=0&id=19613617&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19613617",
  null
  
)

export default component.exports